import type { ClientContext } from '~/services/contextClient';
import type { MessageStandardsClientInterface } from './messageStandardsClient.types';
import CorporateMessageStandardsClient from './corporateMessageStandardsClient';

export default class MessageStandardsClientFactory {
    static createClient(context: ClientContext): MessageStandardsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateMessageStandardsClient(context.teamId);
        }

        throw new Error('Brand standards only supports corporate context');
    }
}
